import Yup from '../../../../../yup';

export default Yup.object().shape({
  vehicle: Yup.string().trim().nullable(),
  vin: Yup.string().trim().nullable(),
  driver: Yup.string().trim().nullable(),
  nickName: Yup.string().trim().nullable(),
});
